import { PageLink } from "../../../_start/layout/core";

export const layoutManagementSubmenu: Array<PageLink> = [
	{
		title: "Menus",
		path: "/layout-management/menus",
		isActive: true,
	},
];
